import React from 'react'

import ReactDOM from 'react-dom'
import Page from '../../Page'
import Form from '../../../components/form/Form';
import {generatePath} from "react-router-dom";
import {Label} from "reactstrap";
import Project from "../../../models/Project";

// console.log('Project', Project);

export default class ProjectStep extends Page {

    formRef = React.createRef();

    static events() {
        return {
            "CreateProject@Submit": (component) => {

                let elem = component.invalidFields();

                if (elem) {
                    const node = ReactDOM.findDOMNode(elem);

                    $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
                }

            }
        }
    }

    static path = null;

    static index = null;
    /**
     * The title shown on the form
     */
    static StepTitle = this.Trans('title');

    static InlineFormActions = true;

    static HideNavbar = false;

    static FormClass = 'wizard-form-step'
    static FormBg = null;

    static WrapperClass = '';

    static ValidationMethodName = null;
    static HandleUnauthorized = true;
    static Optional = false;
    static HideSkip = false;
    static MessageBanner = false;
    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props, context) {
        super(props, context);
        this.childRefs = {};
    }

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     if (!this.constructor.HandleUnauthorized) return true;
    //
    //
    //     if (nextProps.stepNeeded && nextProps.stepNeeded.index < this.constructor.index) {
    //         nextProps.navigate({
    //             pathname: nextProps.stepNeeded.getPath(nextProps.project)
    //         });
    //
    //         return false;
    //     }
    //
    //     return true;
    // }

    componentDidMount() {
        super.componentDidMount();

        this.props.toggleDisabled(false);
    }

    /**
     * @returns {String}
     */
    static TransKey(subKey) {
        let stepKey = this.TranslationKey;

        return `create_project.${stepKey}.${subKey}`;
    }

    /**
     * @returns {String}
     */
    static Trans(transKey, replace = {}) {
        return TB.trans(
            this.TransKey(transKey), replace
        );
    }

    /**
     * @returns {String}
     */
    transKey(subKey) {
        return this.constructor.TransKey(subKey);
    }

    /**
     * @returns {String}
     */
    translate(transKey, replace = {}) {
        return this.constructor.Trans(transKey, replace);
    }

    static getStepName() {
        return TB.isDefined(this.StepName) ?
            this.StepName :
            TB.startCase(this.path.replace('/', ''))
    }

    /**
     * The subtitle shown on the form
     */
    static get StepSection() {
        return Project.ProjectSections.SectionProfile;
    }

    getStepTitle() {
        return this.props.project?.isBYO() ?
            // 'Build Your Own Team' :
            // this.translate('byo_title') :
            'Hire by Open Positions':
            this.props.project.service?.name
    }


    getStepSubtitle() {
        let subtitle = `${this.constructor.StepSection || Project.SectionProfile}`
        let stepName = this.constructor.getStepName();
        if (stepName) {
            subtitle += `: ${stepName}`;
        }
        return subtitle;
    }


    /**
     * The step needed before editing
     */
    static StepNeedsValidation(project) {

        let validationCallback = this.ValidationMethodName;
        if (!validationCallback && this.StepTitle) {
            validationCallback = `validate${String(this.StepTitle)
                .replace('&', '').replace(/\s/g, '')}`
        }

        if (TB.isDefined(project[validationCallback]) && !project[validationCallback]()) {
            return this;
        }

        return false;
    };

    static getPath(project) {
        let projectId = TB.isObject(project) ? project.id : project;
        return generatePath(`${TB.routes().clientProjectSetup}${this.path}`, {projectId})
    }

    /**
     * @param {project} project
     * @returns {Object}
     */
    static reviewMapping(project) {
        return {}
    }

    /**
     * The continue & back buttons
     */
    static showFormButtons() {
        return true
    }

    static showSubmitButton() {
        return true
    }

    handleSubmit = null;

    shouldHandleSubmit(project) {
        return false;
    }

    /**
     * The first invalid field
     */
    invalidFields() {
        if (!this.formRef.current) {
            return false
        }
        let invalid = this.formRef.current.forceValidate();

        if (invalid) {
            const node = ReactDOM.findDOMNode(invalid);

            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
        }
        return invalid;
    }

    async handleInputResponseError(request) {

        // console.log('handleInputResponseError', this.childRefs);

        try {
            if (this.formRef.current) {
                let invalid = await this.formRef.current.handleInputResponseError(request)
                if (invalid) {
                    const node = ReactDOM.findDOMNode(invalid);

                    $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
                    return false;
                }
            }
        } catch (e) {
            console.warn('ERROR: handleInputResponseError', e);
        }

        try {
            let formErrors = {...request.response.data.error.data};
            let nestFormErrors = {};
            let invalidInputs = [];

            TB.map(formErrors, (messages, errorKey) => {
                TB.set(nestFormErrors, errorKey, messages);
            });

            await TB.map(nestFormErrors, async (childForms, formType) => {
                await TB.map(childForms, async (childFormErrors, childFormIndex) => {
                    let childRef = this.childRefs[formType]?.[childFormIndex]?.current;

                    childFormErrors = TB.reduce(childFormErrors, (result, messages, key) => {
                        result[key] = messages.map(message => TB.replace(message, `${formType}.${childFormIndex}.${key}`, key.replace('_', ' ')));
                        return result;
                    }, {});

                    if (childRef) {
                        await childRef.formRef.current.updateInputsWithError(childFormErrors);
                        let invalid = childRef.formRef.current.forceValidate();
                        if (invalid) {
                            invalidInputs.push(invalid);
                        }
                    }
                })
            });

            if (invalidInputs.length) {
                let toScroll = [];
                invalidInputs.map(input => {
                    const node = ReactDOM.findDOMNode(input);

                    if (node) {
                        toScroll.push($(node).offset().top);
                    }
                })
                $('html, body').animate({scrollTop: TB.min(toScroll)}, 1000);

            }
        } catch (e) {
            console.warn('ERROR: handleInputResponseError', e)
        }

    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        return []
    };

    /*
    * Get default required error message
    */
    defaultRequiredValidation(attribute) {
        return {
            isDefaultRequiredValue: TB.trans('validation.required', {attribute})
        }
    }

    forceReset() {
        this.formRef.current.forceReset(this.props.project)
    }

    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     * @param params
     */
    async onSubmit(params) {
        // TB.log().object(
        //     'Create Project @ onSubmit', {...params}
        // );

        this.props.onSubmit({
            params
        });
    }

    /**
     * Handles form change
     *
     * @returns void
     * @param params
     */
    async onChange(params) {
        if (this.props.isDisabled) return;

        // console.log('onChange', params);
        return this.props.onChange(params)
    }

    /**
     * Update prop array at index
     *
     * @returns {Object}
     * @param propName
     * @param index
     * @param model
     */
    updateModelProp = (propName, index, model) => {
        let project = TB.pick({...this.props.project}, propName);

        if (!TB.isEmpty(model)) {
            let updatedModel = {...model};
            for (let [key, value] of Object.entries(updatedModel)) {
                if (TB.isDefined(value) && value instanceof Date) {
                    updatedModel[key] = value.toISOString();
                }
            }
            project = TB.set(project, `${propName}[${index}]`, updatedModel);
        } else {
            TB.unset(project, `${propName}[${index}]`);
        }

        project[propName] = project[propName].filter(params => !TB.isEmpty(params));

        return project;
    }

    /**
     * Handles mapping
     *
     * @returns void
     * @param params
     */
    mapping(params) {
        return params
    }

    generateFormFields() {

        let formFields = TB.map(TB.filter(this.formFields(), formSection => formSection), section => {
            let header = section.header;

            if (!this.props.formOnly && header) {
                section.fields = {
                    [`${TB.slugify(header)}_label`]: (
                        <Label className="col-form-label-hint">
                            {header}
                        </Label>
                    ),
                    ...section.fields
                }
            }

            let fields = {};
            for (let [key, field] of Object.entries(section.fields)) {
                if (field) {
                    fields[key] = field;
                }
            }


            section.fields = fields;

            section.className = "wizard-form-container field-section";

            return section;
        });

        if (this.constructor.Optional && !this.constructor.HideSkip && this.props.nextStep && !this.props.shouldBeRedirected?.()) {
            let {fields,...section} = formFields[formFields.length - 1];

            formFields[formFields.length - 1] = {
                ...section,
                fields: {
                    ...fields,
                    cancel_btn: {
                        style: {flexBasis: '100%',marginTop: 15, display:'flex', justifyContent: 'flex-start'},
                        component: (
                            <button type="button"
                                    disabled={this.props.isDisabled}
                                    onClick={() => this.props.goToStep(
                                        this.props.nextStep
                                    )}
                                    className="mr-3 btn-submit btn btn-link">
                                Skip Question

                            </button>
                        )
                    }
                }
            }
        }

        if (this.constructor.InlineFormActions && formFields.length && this.props.children) {
            let {fields,...section} = formFields[formFields.length - 1];

            formFields[formFields.length - 1] = {
                ...section,
                fields: {
                    ...fields,
                    footer: {
                        style: {flexBasis: '100%', display:'flex', alignItems: 'stretch', flexDirection: 'column'},
                        component: this.props.children
                    }
                }
            }
        }

        return formFields;
    }

    /**
     * Render the form
     *
     * @returns JSX.Element
     */
    render() {
        let {formOnly} = this.props;
        let fields = this.generateFormFields();

        if (this.props.project.isService()) {
            return (
                <div className="project-team-step wizard-form-step">
                        {this.renderFormHeader()}

                        {fields.length > 0 && (
                            <Form
                                ref={this.formRef}
                                showRequired
                                title={null}
                                subtitle={null}
                                submitButton={false}
                                onSubmit={null}
                                background={this.constructor.FormBg}
                                model={this.props.project}
                                mapping={model => this.mapping(model)}
                                onChange={this.onChange.bind(this)}
                                fields={fields}
                                isDisabled={this.props.isDisabled}>

                            </Form>
                        )}
                        {!formOnly && this.renderFormFooter()}
                </div>
            )
        }
        return (
            <div className={this.constructor.WrapperClass}>
                {!formOnly && this.renderMessageBanner()}

                {!formOnly && this.renderTitle()}

                <div className={this.props.formClass || this.constructor.FormClass}>
                    {this.renderFormHeader()}

                    {fields.length > 0 && (
                        <Form
                            ref={this.formRef}
                            showRequired
                            title={null}
                            subtitle={null}
                            submitButton={false}
                            onSubmit={null}
                            background={this.constructor.FormBg}
                            model={this.props.project}
                            mapping={model => this.mapping(model)}
                            onChange={this.onChange.bind(this)}
                            fields={fields}
                            isDisabled={this.props.isDisabled}>

                        </Form>
                    )}
                    {!formOnly && this.renderFormFooter()}
                </div>
            </div>
        )

    }

    renderMessageBanner() {
        if(!this.constructor.MessageBanner) return null;

        return (
            <div className="nav-alert">
                <p>
                    {this.constructor.MessageBanner}
                </p>
            </div>
        )
    }

    renderFormFooter() {
        return null;
    }

    renderFormHeader() {
        return null;
    }

    renderTitle() {
        return (
            <div className={"step-title-container"}>
                {this.getStepTitle() && (
                    <h4 className="step-title">{this.getStepTitle()}</h4>
                )}
                {this.getStepSubtitle() && (
                    <h1 className="step-section">{this.getStepSubtitle()}</h1>
                )}
            </div>
        )
    }
}